import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { MaskedInputForm } from '../MaskedInputForm';

interface CepFieldProps {
  name: string | undefined | any;
  label?: string;
  placeholder?: string;
  control: any;
  errors: any;
  isLoading?: boolean;
  isDisabled?: boolean;
  notFoundMessage?: string;
}

export const CepField = ({
  name,
  label = 'CEP',
  placeholder,
  control,
  errors,
  isLoading,
  isDisabled,
  notFoundMessage,
}: CepFieldProps) => (
  <Box>
    <MaskedInputForm
      name={name}
      label={label}
      placeholder={placeholder}
      control={control}
      errors={errors}
      mask="99999-999"
      isRequired
      isDisabled={isDisabled}
      isLoading={isLoading}
    />
    {notFoundMessage && !errors?.[name] && (
      <Text fontSize="12px" lineHeight="16px" color="state.destructive" mt="8px" role="alert">
        {notFoundMessage}
      </Text>
    )}
  </Box>
);
